import React, { useEffect, useState } from 'react'
import { PositionsTableToggle } from './PositionsTableToggle'
import { useStatistics } from '../../hooks/statistics.hook'
import Pagination from '../pagination/pagination'
import { UserPositionsTable } from './UserPositionsTable'

export const UserPositions = ({ stages, user, payload }) => {
  const { getUserPositions } = useStatistics()
  const [meta, setMeta] = useState([])
  const [page, setPage] = useState(null)
  const [positions, setPositions] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const userId = user.id
  const displayedStagesIds = stages.map(st => st.id)

  const getPositionsList = async () => {
    try {
      setIsLoading(true)
      const data = {
        users: [userId],
        stages: displayedStagesIds,
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo,
        page
      }
      if(payload.drawings) {
        data.drawingGroups = payload.drawings
      }
      const {meta, positions} = await getUserPositions(data)
      setMeta(meta)
      setPositions(positions)
    } catch(e) {
      console.error('getPositionsList', e)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if(!page) return;
    getPositionsList()
  }, [page])

  const onPositionsRequest = () => {
    setPage(1)
  }

  const onPageChange = (page) => {
    setPage(page)
  }

  return (
    <div>
      {!!positions.length && isOpen &&
        <div className={`overflow-hidden`}>
          <UserPositionsTable positions={positions} />
          {meta.pageCount > 1 && <div className='w-[100%] relative h-[6.8rem] bg-[#FFFFFF] mt-[8px] px-[22px]'>
            <Pagination {...meta} onPageChange={onPageChange} statPage></Pagination>
          </div>
          }
        </div>
      }
      <PositionsTableToggle
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onPositionsRequest={onPositionsRequest}
        isLoading={isLoading}
      />
    </div>
  )
}
